import React from "react";
import { useTranslation } from "react-i18next";

export const Header = (props) => {
  const { t } = useTranslation();

  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                {props.data && props.data.img ? 
                  <img className="intro-logo" draggable="false" src={props.data.img} alt="..." /> :
                  <h1>
                  {props.data && props.data ? t("Header.title") : "Loading"}
                  <span></span>
                  </h1>
                }
                
                <p style={{"margin-top": 10, "user-select": "none"}}>{props.data ? t("Header.paragraph") : "Loading"}</p>
                <a
                  href="#about"
                  className="btn btn-custom page-scroll"
                >
                  {t("Header.actionButton")}
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
